import React from "react";
import PageTemplate from "../components/template/PageTemplate";

const Blog = () => {
  return (
    <PageTemplate>
    <section className="page-content">
      <h1 className="page-heading">Blog</h1>
      <p>Check out my latest thoughts and tutorials on design and coding.</p>
    </section>
    </PageTemplate>
  );
};

export default Blog;
